import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { ValueAddingView } from '../../features/operating-costs/value-adding-view';

export const Route = createFileRoute('/operating-costs/value-adding')({
  staticData: {
    breadcrumb: 'Value-adding',
  },
  component: ValueAddingPage,
});

/**
 * Renders the value-adding operating costs view when the feature is enabled.
 */
function ValueAddingPage() {
  const enabled = useFeatureFlag('operating_costs');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Operating costs are not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <ValueAddingView partnerId={partnerId} />;
}
